import { toast, Toaster } from 'sonner';

import ErrorSvg from './svgs/error';
import InfoSvg from './svgs/info';
import LoadingSvg from './svgs/loading';
import SuccesssSvg from './svgs/success';

const ToastCard = ({ toastId, title, description, type, showClose = true, onClick }) => (
    <div
        onClick={onClick}
        style={{
            width: "100%",
            maxWidth: 420,
            borderRadius: 12,
            boxShadow: "0 4px 16px rgba(0,0,0,0.08)",
            border: onClick ? "1px solid #26890d" : "none",
            padding: "18px 22px",
            display: "flex",
            alignItems: "center",
            background: "#fff",
            color: "#222",
            fontFamily: "'Segoe UI', 'Roboto', Arial, sans-serif",
            fontSize: "15px",
            margin: "0 auto",
            cursor: onClick ? "pointer" : "default",
        }}
    >
        <div style={{ marginRight: 12, display: "flex", alignItems: "center" }}>
            {type === "success" && <SuccesssSvg />}
            {type === "error" && <ErrorSvg />}
            {type === "info" && <InfoSvg />}
            {type === "loading" && <LoadingSvg />}
        </div>
        <div style={{ flex: 1, minWidth: 0 }}>
            <div style={{
                fontWeight: 600,
                fontSize: "16px",
                marginBottom: description ? "7px" : 0,
                lineHeight: "1.3",
                wordBreak: "break-word"
            }}>
                {title}
            </div>
            {description && (
                <div style={{
                    fontSize: "14px",
                    color: "#444",
                    lineHeight: "1.5",
                    wordBreak: "break-word",
                    whiteSpace: "pre-line"
                }}>
                    {description}
                </div>
            )}
        </div>
        {onClick && (
            <div style={{
                marginLeft: 12,
                padding: "6px 14px",
                borderRadius: 20,
                background: "#26890d",
                color: "#fff",
                fontSize: "13px",
                fontWeight: 600,
                whiteSpace: "nowrap",
                flexShrink: 0,
            }}>
                Download
            </div>
        )}
        {showClose && (
            <button
                onClick={(e) => {
                    e.stopPropagation();
                    toast.dismiss(toastId);
                }}
                style={{
                    background: "none",
                    border: "none",
                    color: "#888",
                    cursor: "pointer",
                    fontSize: "22px",
                    marginLeft: 16,
                    padding: 0,
                    lineHeight: 1,
                }}
                aria-label="Close"
            >
                ×
            </button>
        )}
    </div>
);

export const showToast = ({
    title,
    description,
    type = "success",
    duration = 5000,
    id = "org-toast",
    onClick,
}) => {
    toast.custom(
        (t) => (
            <ToastCard
                toastId={id}
                title={title}
                description={description}
                type={type}
                onClick={onClick ? () => { onClick(); toast.dismiss(id); } : undefined}
            />
        ),
        {
            duration,
            id, // <-- Same id across calls ensures only one toast at a time per id
        }
    );
};

// Shows a persistent loading toast (no close button, no auto-dismiss) and
// returns its id — pass that id to dismissToast() once the operation settles,
// or to showToast()'s `id` option to swap it in place for the success/error state.
export const showLoadingToast = ({ title, description, id = "org-toast" }) => {
    toast.custom(
        (t) => (
            <ToastCard toastId={id} title={title} description={description} type="loading" showClose={false} />
        ),
        {
            duration: Infinity,
            id,
        }
    );
    return id;
};

export const dismissToast = (id = "org-toast") => toast.dismiss(id);

export const CustomToaster = () => (
    <Toaster
        position="top-right"
        theme="light"
        toastOptions={{
            style: {
                margin: "12px 0",
                zIndex: 9999,
            }
        }}
    />
);